<template>
  <span class="mb-info-wrap" @mouseenter="openHover" @mouseleave="closeHover">
    <!-- UX: ⓘ an jedem Label. Öffnet per Hover/Fokus (Desktop) und per Tap (Touch). -->
    <button
      ref="trigger"
      type="button"
      class="mb-info"
      :aria-expanded="open ? 'true' : 'false'"
      :aria-label="title ? `Definition: ${title}` : 'Mehr Informationen'"
      @click.stop.prevent="toggle"
      @focus="openHover"
      @blur="closeHover"
    >
      i
    </button>
    <Teleport to="body">
      <div v-if="open && pinned" class="mb-info__back" @click="close" />
      <div v-if="open" class="mb-info__pop" role="tooltip" :style="popStyle">
        <p v-if="title" class="mb-info__title">{{ title }}</p>
        <p v-if="text" class="mb-info__text">{{ text }}</p>
        <p v-if="formula" class="mb-info__formula">{{ formula }}</p>
        <ul v-if="items.length" class="mb-info__list">
          <li v-for="item in items" :key="item.label">
            <strong>{{ item.label }}:</strong> {{ item.value }}
          </li>
        </ul>
      </div>
    </Teleport>
  </span>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

defineProps({
  title: { type: String, default: '' },
  text: { type: String, default: '' },
  formula: { type: String, default: '' },
  items: { type: Array, default: () => [] }
});

const open = ref(false);
// UX: Per Klick geöffnete Tooltips bleiben stehen (Touch), Hover-Tooltips schließen beim Verlassen.
const pinned = ref(false);
const trigger = ref(null);
const popStyle = ref({});

function position() {
  const rect = trigger.value?.getBoundingClientRect();
  if (!rect) {
    popStyle.value = {};
    return;
  }
  const width = Math.min(320, window.innerWidth - 24);
  popStyle.value = {
    position: 'fixed',
    top: `${rect.bottom + 6}px`,
    left: `${Math.max(12, Math.min(rect.left, window.innerWidth - width - 12))}px`,
    maxWidth: `${width}px`,
    zIndex: 200
  };
}

function openHover() {
  if (open.value) return;
  position();
  pinned.value = false;
  open.value = true;
}

function closeHover() {
  if (!pinned.value) open.value = false;
}

function toggle() {
  if (open.value && pinned.value) {
    close();
    return;
  }
  position();
  pinned.value = true;
  open.value = true;
}

function close() {
  open.value = false;
  pinned.value = false;
}

function onKey(event) {
  if (event.key === 'Escape') close();
}

onMounted(() => {
  window.addEventListener('keydown', onKey);
  window.addEventListener('scroll', close, { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKey);
  window.removeEventListener('scroll', close);
});
</script>
